import { render, staticRenderFns } from "./add_company_model.vue?vue&type=template&id=06514ecc&scoped=true&"
import script from "./add_company_model.vue?vue&type=script&lang=js&"
export * from "./add_company_model.vue?vue&type=script&lang=js&"
import style0 from "./add_company_model.vue?vue&type=style&index=0&id=06514ecc&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06514ecc",
  null
  
)

export default component.exports